const defaultLocation = 'United Kingdom';

export type SearchBarLocationSelection = {
    name: string;
};

export type SearchBarLocationState = {
    selectedSuggestion: SearchBarLocationSelection | undefined;
    suggestions: {
        name: string;
    }[];
    value: string;
    defaultLocation: typeof defaultLocation;
    useRecentHistory: boolean;
    initialValue: string | undefined;
};

export const defaultState: SearchBarLocationState = {
    selectedSuggestion: undefined,
    suggestions: [],
    value: defaultLocation,
    defaultLocation,
    useRecentHistory: false,
    initialValue: undefined,
};

export default (
    state: SearchBarLocationState = defaultState,
    action: {
        type: string;
        suggestions?: any[];
        useRecentHistory?: boolean;
        suggestion?: { name: string; type: string };
        location?: string;
    }
): SearchBarLocationState => {
    switch (action.type) {
        case 'SET_SEARCH_BAR_LOCATION_SUGGESTIONS':
            return Object.assign({}, state, {
                suggestions: action.suggestions,
                useRecentHistory: action.useRecentHistory,
            });
        case 'SELECT_SEARCH_BAR_LOCATION_SUGGESTION':
            return Object.assign({}, state, {
                selectedSuggestion: action.suggestion,
            });
        case 'SET_SEARCH_BAR_LOCATION':
            return Object.assign({}, state, {
                value: action.location,
            });
        case 'SET_INITIAL_SEARCH_BAR_LOCATION':
            return Object.assign({}, state, {
                value: action.location,
                initialValue: action.location,
            });
        default:
            return state;
    }
};
